var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "padding-top-5xl", attrs: { id: "related" } },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("div", { staticClass: "row roomy margin-bottom-xl" }, [
            _c(
              "div",
              { staticClass: "column-12 tablet:column-8 laptop:column-9" },
              [
                _c(
                  "h3",
                  { staticStyle: { "--margin-bottom": "var(--spacing-3xs)" } },
                  [_vm._v("An Icon Collection Packed with Packs")]
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.iconPack().label) +
                      " is one of several icon packs, each with a unique personality and pixel-perfectly designed."
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "display-none tablet:display-block column-12 tablet:column-4 laptop:column-3 tablet:text-right",
                staticStyle: {
                  "--button-hover-background":
                    "var(--theme-button-hover-background)",
                  "--button-hover-border-color":
                    "var(--theme-button-hover-border-color)",
                },
              },
              [
                _c(
                  "site-link",
                  {
                    staticClass: "button flat with-border margin-bottom-0",
                    staticStyle: {
                      "--border-color": "var(--fa-gravy)",
                      "--button-background": "transparent",
                      "--button-color": "var(--fa-navy)",
                    },
                    attrs: { to: { name: "latest.icons.packs" } },
                    nativeOn: {
                      click: function ($event) {
                        _vm.$posthog.capture(
                          "pack_landing:all_packs_link_click",
                          { pack: _vm.iconPack().name }
                        )
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "display-none laptop:display-inline" },
                      [_vm._v("View ")]
                    ),
                    _vm._v(" All Packs\n          "),
                    _c("font-awesome-icon", {
                      staticClass: "margin-left-md",
                      attrs: {
                        icon: _vm.$v6.solid.faGrid2,
                        "fixed-width": "",
                        size: "lg",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("icon-packs-list"),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }